import moment from "moment";
import React from "react";
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

class DateRangePickerContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment().utc(),
      endDate: moment().utc(),
      focusedInput: "START_DATE",
    };
  }

  render() {

    const { onDatesChange } = this.props;

    return (
      <DateRangePicker
        startDate={this.state.startDate} // momentPropTypes.momentObj or null,
        startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
        endDate={this.state.endDate} // momentPropTypes.momentObj or null,
        endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
        displayFormat="YYYY/MM/DD"
        numberOfMonths={1}
        autoFocus
        transitionDuration={0}
        onDatesChange={({ startDate, endDate }) => {
          if(startDate && endDate){
            if(endDate.isAfter(startDate.clone().add(365, 'days'))){
              endDate = startDate.clone().add(365, 'days');
            }
            this.setState({ startDate, endDate });
            onDatesChange({ startDate, endDate });
          }
        }} // PropTypes.func.isRequired,
        isOutsideRange={day => (
          (day.isAfter(this.state.startDate.clone().add(365, 'days')))
        )}
        focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
        onFocusChange={(focusedInput) => this.setState({ focusedInput })} // PropTypes.func.isRequired,
      />
    );
  }
}

export default DateRangePickerContainer;
